export default __webpack_public_path__ + "static/media/hangarJet.3b5ff38e.jpg";